import { useCallback } from 'react';

import config from 'Config';
import useRequestIdleCallback from 'Hooks/useRequestIdleCallback';

import trackPerf from '../lib/trackClientPerformance';

const usePerfTracking = ({
  executeEvent,
}: {
  executeEvent: (eventName: string, payload: Record<string, any>) => void;
}) => {
  const handlePerfTracking = useCallback(() => {
    if (config.perf.enabled) {
      trackPerf(executeEvent);
    }
  }, [executeEvent]);

  useRequestIdleCallback(handlePerfTracking);
};

export default usePerfTracking;
